import { createScanDocAIConfig } from "scandoc-react-components";
//
export const PMS_ID = "oracle";
export const PMS_BACKEND_URL = "https://api.scandoc.ai/pms/";
//
export const VERSION = '0.0.12';
console.log("Version:" + VERSION);
//===========================


// This has to be a single line like this for the CI/CD to insert the needed values for automatic deploy
createScanDocAIConfig('50fdc2e4-e921-4f5a-a523-a14a8a67c921d43089b0-bdcd-48d6-8ca3-e96b1aa8e6a94b2d27df-21be-4839-99e4-411974c16e645c0837b4-fcc5-4a48-847e-802a8b44525d7f41d0bd-3ed2-485d-b710-b33b21ae379f109009dc-a2d2-4246-9723-6ed4483830c87f2d1a54-452e-40a4-8a22-005d2ec73543a2926727-f236-4507-95c3-ef51d020d3dd9632c1ff-170a-4839-9dac-1597694e911420e3f19f-fdb0-4227-85d3-55d39aa142ee', '');
